import Backbone from 'backbone';
import $ from 'jquery';
import { BackboneViewProps } from '../types';

require('jquery.easing');

const template = require('./setup.pug');

export default Backbone.View.extend({
  events: {
    'click .button_next': 'button_next',
    'click .button_previous': 'button_previous',
    'click .submit': 'submit',
    'mouseover .promo-example': 'promo_in',
    'mouseout .promo-example': 'promo_out',
    'click .promo-example': 'click_promo',
    'click .remove': 'remove_func',
    'click .removeOrder': 'remove_order_func',
    'click #btn-one': 'click_one',
    'click #btn-two': 'click_two',
    'click #btn_results': 'event_results',
  },

  click_one() {
    $('#btn-one')
      .html(
        '<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>Loading...'
      )
      .addClass('disabled');
    setTimeout(function () {
      $('#btn-one')
        .html('Success - Hubspot Connected')
        .addClass('btn-success mid')
        .removeClass('disabled')
        .blur();
    }, 2000);
  },

  click_two() {
    $('#btn-two')
      .html(
        '<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>Loading...'
      )
      .addClass('disabled');
    setTimeout(function () {
      $('#btn-two')
        .html('Success - Calendly Connected')
        .addClass('btn-success mid')
        .removeClass('disabled')
        .blur();
    }, 2000);
  },

  remove_func() {
    $(this).closest('.rowKey').remove();
  },

  remove_order_func() {
    $(this).closest('.card').remove();
  },

  newOrder() {
    const orderNumber = $('.card').length;
    // var orderNumber = $(".card").index(this);
    $('.creation').prepend(
      `<div class="card animated zoomIn">\r\n\t\t<h2 class="fs-title" style="    padding-top: 25px;\r\n    padding-left: 25px;\r\n    text-align: left;\r\n    width: 100%;">Product description n\u00B0${orderNumber}</h2>\r\n<div class="row">\r\n      <div class="input-field col s12">\r\n          <input  id="first_name${orderNumber}" type="text" class="validate">\r\n          <label for="first_name${orderNumber}">Order name</label> \r\n        </div> \r\n  <div class="row col s12" style="color:grey;font-size: 10px;text-align: left;margin-top: -10px;margin-left: 0px">Name your order, you can also use a reference Id from your system to find it easily </div>\r\n      </div>\r\n    <div class="row">\r\n      <div class="input-field col s12">\r\n          <input  id="first_name2${orderNumber}" type="text" class="validate">\r\n          <label for="first_name2${orderNumber}">URL (optional)</label> \r\n        </div> \r\n     \r\n      <div class="row col s12" style="color:grey;font-size: 10px;text-align: left;margin-top: -10px;margin-left: 0px">You can add an url to give more informations to the writer</div> </div> \r\n      \r\n       <div class="row">\r\n      <div class="input-field col s12">\r\n          <input  id="first_name2${orderNumber}" type="text" class="validate">\r\n          <label for="first_name2${orderNumber}">Reference id (optional)</label> \r\n        </div> \r\n     \r\n      <div class="row col s12" style="color:grey;font-size: 10px;text-align: left;margin-top: -10px;margin-left: 0px">You can add a reference id to match the order with your system</div> </div>  \r\n  <div class="keywords">    \r\n<!-- <div class="row">\r\n        <div class="input-field col s6">\r\n          <i class="material-icons prefix">label</i>\r\n          <input id="icon_prefix${orderNumber}" type="text" class="validate">\r\n          <label for="icon_prefix${orderNumber}">Keyword</label>\r\n        </div>\r\n   <div class="row">\r\n    <div style="margin-top:2rem" class="col s2"> Density</div> \r\n     <div class="input-field col s2"> Density</div>\r\n        <div class="input-field col s2">\r\n          <input id="icon_telephone${orderNumber}" type="number" class="validate">\r\n          <label for="icon_telephone${orderNumber}">Min</label>\r\n        </div>\r\n        <div class="input-field col s2">\r\n          <input id="max${orderNumber}" type="number" class="validate">\r\n          <label for="max${orderNumber}">Max</label>\r\n        </div>\r\n    </div>\r\n       </div>-->\r\n    \r\n\r\n    </div>\r\n          <div><a class="waves-effect waves-light btn" onClick="nthis.ewKeyword()"><i class="material-icons left">add</i>Add a Keyword</a></div> \r\n      </div>\r\n    </div>`
    );
    this.orderCounter += 1;
    this.counter += 1;
  },

  click_promo() {
    $('.promo-example').removeClass('selected');
    $(this).addClass('selected');
  },

  promo_in() {
    $(this).addClass('hovered');
  },
  promo_out() {
    $(this).removeClass('hovered');
  },

  submit() {
    return false;
  },

  button_previous(ev: any) {
    if (this.animating) return false;
    this.animating = true;

    const current_fs = $(ev.currentTarget).parent();
    const previous_fs = $(ev.currentTarget).parent().prev();
    // de-activate current step on progressbar
    $('#progressbar li')
      .eq($('fieldset').index(current_fs))
      .removeClass('active');
    // show the previous fieldset
    previous_fs.show();
    // hide the current fieldset with style
    current_fs.animate(
      {
        opacity: 0,
      },
      {
        step(now) {
          // as the this.opacity of this.current_fs reduces to 0 - stored in "now"
          // 1. this.scale this.previous_fs from 80% to 100%
          this.scale = 0.8 + (1 - now) * 0.2;
          // 2. take this.current_fs to the right(50%) - from 0%
          this.left = `${(1 - now) * 50}%`;
          // 3. increase this.opacity of this.previous_fs to 1 as it moves in
          this.opacity = 1 - now;
          current_fs.css({
            left: this.left,
          });
          previous_fs.css({
            transform: `scale(${this.scale})`,
            opacity: this.opacity,
          });
        },
        duration: 500,
        complete: function () {
          current_fs.hide();
          this.animating = false;
        }.bind(this),
        easing: 'easeOutQuint',
      }
    );
  },

  button_next(ev: any) {
    if (this.animating) return false;
    this.animating = true;

    const current_fs = $(ev.currentTarget).parent();
    const next_fs = $(ev.currentTarget).parent().next();

    // activate next step on progressbar using the index of this.next_fs
    $('#progressbar li').eq($('fieldset').index(next_fs)).addClass('active');

    // show the next fieldset
    next_fs.show();
    // hide the current fieldset with style
    current_fs.animate(
      {
        opacity: 0,
      },
      {
        step(now) {
          // as the this.opacity of this.current_fs reduces to 0 - stored in "now"
          // 1. this.scale this.current_fs down to 80%
          this.scale = 1 - (1 - now) * 0.2;
          // 2. bring this.next_fs from the right(50%)
          this.left = `${now * 50}%`;
          // 3. increase this.opacity of this.next_fs to 1 as it moves in
          this.opacity = 1 - now;
          current_fs.css({
            transform: `scale(${this.scale})`,
          });
          next_fs.css({
            left: this.left,
            opacity: this.opacity,
          });
        },
        duration: 500,
        complete: function () {
          current_fs.hide();
          this.animating = false;
        }.bind(this),
        // this comes from the custom easing plugin
        easing: 'easeOutQuint',
      }
    );
  },

  initialize(options: BackboneViewProps) {
    this.counter = 0;
    this.orderCounter = 1;
    this.tenant = options.tenant;
    this.animating = false;
    // this.next_fs, this.previous_fs; //fieldsets
    // this.left, this.opacity, this.scale; //fieldset properties which we will animate
    // this.animating; //flag to prevent quick multi-click glitches
  },

  newKeyword() {
    $('.keywords').append(
      `<div class="row rowKey animated zoomIn2">\r\n        <div class="input-field col s6" style="\r\n    width: 42%;\r\n">\r\n          \r\n          <input id="icon_prefix1${this.counter}" type="text" class="validate">\r\n          <label for="icon_prefix1${this.counter}" class="">Keyword</label>\r\n        </div>\r\n   <div class="row">\r\n    <!--<div style="    top: 0.8rem;" class="col s2"> Density :</div> -->\r\n     <div class="input-field col s2" style="    top: 0.7rem;"> Density</div>\r\n        <div class="input-field col s2">\r\n          <input id="icon_telephone1${this.counter}" type="number" class="validate">\r\n          <label for="icon_telephone1${this.counter}" class="">Min</label>\r\n        </div>\r\n        <div class="input-field col s2">\r\n          <input id="max1${this.counter}" type="number" class="validate">\r\n          <label for="max1${this.counter}" class="">Max</label>\r\n        </div>\r\n    <i class="material-icons prefix remove active" style="\r\n    margin-top: 1.7rem; cursor: pointer;color: #607D8B;\r\n">close</i></div>\r\n       </div>`
    );
    this.counter += 1;
  },
  event_results(event: any) {
    event.preventDefault();
    Backbone.history.navigate(`/org/${this.tenant}/results`, true);
  },

  async render() {
    const html = template();
    await this.$el.html(html);
    return this;
  },
});
